import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/background.jpg";
import botImage from "../assets/bot.png";
import ChatbotIcon from "../assets/chatbot.png";
import Logo from "../assets/slt-mobitel-logo.png";
import "../styles/style.css";
import Footer from "./Footer";

const Home = () => {
  const navigate = useNavigate();
  const [chatbotVisible, setChatbotVisible] = useState(false);
  const [chatbotLoaded, setChatbotLoaded] = useState(false);

  useEffect(() => {
    const loadWebChatLibrary = () =>
      new Promise((resolve, reject) => {
        if (window.WebChat) {
          resolve(window.WebChat);
        } else {
          const script = document.createElement("script");
          script.src =
            "https://cdn.botframework.com/botframework-webchat/latest/webchat.js";
          script.onload = () => resolve(window.WebChat);
          script.onerror = () =>
            reject(new Error("WebChat library failed to load"));
          document.body.appendChild(script);
        }
      });

    const loadChatbot = async () => {
      try {
        const WebChat = await loadWebChatLibrary();
        const response = await fetch("http://127.0.0.1:5002/get_token", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) throw new Error("Failed to fetch token from server");

        const data = await response.json();
        const token = data.token;
        if (!token) throw new Error("No token received from server");

        const directLine = WebChat.createDirectLine({ token });

        WebChat.renderWebChat(
          {
            directLine: directLine,
            userID: "user-001",
            username: "User",
            locale: "en-US",
            styleOptions: {
              botAvatarInitials: "AI",
              userAvatarInitials: "U",
              bubbleBackground: "#F1F1F1",
              bubbleFromUserBackground: "#0078D7",
              bubbleFromUserTextColor: "white",
              rootHeight: "100%",
              rootWidth: "100%",
            },
          },
          document.getElementById("webchat")
        );

        console.log("Chatbot loaded!");
      } catch (error) {
        console.error("Error loading chatbot:", error);
      }
    };

    if (chatbotVisible && !chatbotLoaded) {
      loadChatbot();
      setChatbotLoaded(true);
    }
  }, [chatbotVisible, chatbotLoaded]);

  const handleCloseChatbot = () => {
    setChatbotVisible(false);
    setChatbotLoaded(false);
  };

  return (
    <div
      style={{
        minHeight: "94vh",
        position: "relative",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "20px",
        fontFamily: "'Poppins', sans-serif",
        textAlign: "center",
      }}
    >
      {/* Responsive CSS inside <style> */}
      <style>{`
        /* Mobile (≤767px) */
        @media screen and (max-width: 767px) {
          .container {
            font-size: 14px;
            line-height: 1.6;
          
            margin-bottom: 20px;
            padding-top: 10px;
          }
          .header {
            font-size: 30px;
            margin-bottom: 15px;
            padding-top: 30px;
          }
          .button {
            padding: 10px 18px;
            font-size: 10px;
            margin-top: 15px;
          }
          .bot-image {
            width: 70%;
            max-width: 220px;
            margin: 20px auto 0;
            padding-bottom: 70px;
          }
          .chatbot-window {
            width: 90%;
            height: 45%;
            bottom: 0;
            left: 15px;
            border-radius: 12px 12px 0 0;
          }
          .floating-ball {
            bottom: 70px;
            right: 20px;
            width: 50px;
            height: 50px;
            padding: 6px;
          }
        }

        /* Very Small Devices (≤480px) */
        @media screen and (max-width: 480px) {
          .bot-image {
            width: 80%;
            max-width: 180px;
          }
          .chatbot-window {
            height: 75%;
          }
          .floating-ball {
            width: 45px;
            height: 45px;
          }
        }
      `}</style>
      <img
        src={Logo}
        alt="Logo"
        className="logo2"
        style={{ width: "150px", height: "auto", cursor: "pointer" }}
        onClick={() => navigate("/")}
      />

      <div className="header">Welcome to Our AI Agent Assistant!</div>
      <div className="container">
        Our smart AI Assistant is designed to support you throughout your
        internship journey. Whether you're applying, in the middle of training,
        or wrapping things up.
        <i style={{ color: "#52BDEF" }}>
          Need help with your internship? Tap the chat icon..
        </i>
      </div>

      <button className="button" onClick={() => navigate("/readmore")}>
        READ MORE
      </button>

      {/* Bot Image on Right Middle Corner */}
      <img src={botImage} alt="Bot" className="bot-image" />

      {/* Background overlay */}
      {chatbotVisible && (
        <div
          onClick={handleCloseChatbot}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 999,
          }}
        />
      )}

      {/* Floating Chat Icon */}
      <div
        className="floating-ball"
        onClick={() => setChatbotVisible(true)}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
          e.currentTarget.style.boxShadow =
            "0px 0px 15px 5px rgba(74, 222, 241, 0.97)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        <img
          src={ChatbotIcon}
          alt="Chatbot Icon"
          style={{
            width: "45px",
            height: "45px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Chatbot Window */}
      {chatbotVisible && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            AI Assistant
            <span className="chatbot-close" onClick={handleCloseChatbot}>
              ×
            </span>
          </div>
          <div id="webchat" className="chatbot-content"></div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Home;
